import React from 'react';

import { Modal } from '@r-client/shared/ui/modal';

import { TGetEventsEventDetails } from '../../types';
import { RsvpContainer } from './rsvp-container';

export interface IRsvpModalProps {
  event: Omit<NonNullable<TGetEventsEventDetails>, 'offerings'>;
  isModalOpen: boolean;
  onCloseModal: () => void;
}

export const RsvpModal: React.FC<React.PropsWithChildren<IRsvpModalProps>> = ({
  event,
  isModalOpen,
  onCloseModal,
}) => {
  return (
    <Modal
      fixedWidth
      width="medium"
      closeModal={onCloseModal}
      isModalOpen={isModalOpen}
    >
      <RsvpContainer event={event} />
    </Modal>
  );
};
